import React, { Component } from "react";
import styled from "styled-components";
import Alert from "@material-ui/lab/Alert";
import PropTypes from "prop-types";

const propTypes = {
  verificationCode: PropTypes.shape({
    value: PropTypes.string.isRequired,
    expirationDate: PropTypes.instanceOf(Date).isRequired,
  }),
};

const StyledAlert = styled(Alert)`
  position: absolute;
  top: 80px;
  left: 0px;
`;

class CodeTimer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      minutesToExpire: this.getMinutesToExpire(),
    };

    this.intervalId = setInterval(
      () => this.updateMinutesToExpire(),
      1000 * 15
    );
  }

  componentWillUnmount() {
    clearInterval(this.intervalId);
  }

  getMinutesToExpire() {
    const { expirationDate } = this.props.verificationCode;
    return Math.floor((expirationDate - new Date()) / (1000 * 60));
  }

  updateMinutesToExpire() {
    const minutesToExpire = this.getMinutesToExpire();
    this.setState({ minutesToExpire });

    if (minutesToExpire < 0) {
      clearInterval(this.intervalId);
    }
  }

  render() {
    if (this.state.minutesToExpire < 0) {
      return null;
    }

    return (
      <StyledAlert severity="info">
        <strong>{this.props.verificationCode.value}</strong> is your
        verification code. It expires in{" "}
        <strong>
          {this.state.minutesToExpire === 0
            ? "less than 1"
            : this.state.minutesToExpire}
        </strong>{" "}
        minute{this.state.minutesToExpire > 1 ? "s" : ""}.
      </StyledAlert>
    );
  }
}

CodeTimer.propTypes = propTypes;
export default CodeTimer;
